<template>
    <v-container fluid class="indice-preco-page-container">
        <toolbar-indices-preco v-if="!ehTelaHistoricoReajuste" @btnNovoReajusteClicado="deveMostrarModalReajusteEmLote = true"/>

        <div class="d-flex-inline pa-md-5 px-3 mt-3" v-if="ehTelaHistoricoReajuste" style="align-items: center; margin-top: 10px !important;">
            <v-icon small color="primary" class="mr-2">chevron_left</v-icon>
            <a href="" @click.prevent="processarEventoVoltarParaListagem" class="primary--text" style="text-decoration: none">Voltar para Listagem</a>
        </div>

        <v-slide-y-transition>
            <novo-reajuste-e-historico v-if="ehTelaHistoricoReajuste"
                                       class="pa-md-5 pa-3"
                                       :modalidade="modalidadeSelecionada"
                                       :reajustes="historicoReajustes"
                                       @eventoSalvarTipo="processarEventoSalvarTipo"
                                       @eventoRemoverReajuste="processarEventoRemoverReajuste"
                                       @eventoSalvarNovoPercReajuste="processarEventoEditarPercReajuste"
                                       @eventoSalvarNovoReajuste="processarEventoSalvarNovoReajuste"
                                       @voltarParaListagem="processarEventoVoltarParaListagem"
            />

            <listar-ultimos-reajustes-todas-modalidades
                class="pa-md-5 pa-3"
                v-if="!ehTelaHistoricoReajuste"
                :reajustes="ultimosReajustesPorModalidade"
                @editarModalidade="processarEventoVisualizarHistorico"/>
        </v-slide-y-transition>

        <modal-reajuste-em-lote
            :deveMostrarModalReajusteEmLote="deveMostrarModalReajusteEmLote"
            :dadosReajusteEmLote="dadosReajusteEmLote"
            :historicoUltimoAnoReajuste="ultimosReajustesPorModalidade"
            @fecharModalReajusteEmLote="deveMostrarModalReajusteEmLote = false"
            @salvarReajusteEmLote="processarEventoSalvarReajusteEmLote"/>

        <modal-nova-modalidade :deveMostarModalNovaModalidade="deveMostarModalNovaModalidade"
                               @confirmar="processarEventoConfirmarCriarNovaModalidade"
                               @cancelar="deveMostarModalNovaModalidade = false"/>
    </v-container>
</template>

<script>
import ToolbarIndicesPreco from '../components/ToolbarIndicePreco'
import NovoReajusteEHistorico from './novo-reajuste/NovoReajusteEHistorico.vue'
import {actionTypes} from '@/core/constants'
import ModalNovaModalidade from '../components/ModalNovaModalidade'
import ListarUltimosReajustesTodasModalidades from './listagem-ultimo-ano/ListarUltimosReajustesTodasModalidades'
import ModalReajusteEmLote from '../components/ModalReajusteEmLote'

const reajusteCorrente = {
    id: null,
    modalidade: {},
    ano: (new Date()).getFullYear(),
    indicador: 'IPCA',
    valorBase: null,
    percentualReajuste: null,
    valorAtualizado: 0
}

const reajusteEmLote = {
    anoBase: (new Date()).getFullYear(),
    anoIndicador: (new Date()).getFullYear() - 1,
    indicador: 'IPCA',
    percentualReajuste: null
}

export default {
    name: 'PagePrincipalIndicePreco',
    components: {
        ModalReajusteEmLote,
        ListarUltimosReajustesTodasModalidades,
        ModalNovaModalidade,
        NovoReajusteEHistorico,
        ToolbarIndicesPreco
    },
    data: () => {
        return {
            ehTelaHistoricoReajuste: false,
            dadosReajusteCorrente: { ...reajusteCorrente },
            historicoReajustes:[],
            ultimosReajustesPorModalidade:[],
            modalidadesCadastradas:[],
            modalidadeSelecionada: null,
            deveMostarModalNovaModalidade: false,
            dadosReajusteEmLote: {...reajusteEmLote},
            deveMostrarModalReajusteEmLote: false,
        }
    },
    computed: {
        getModalidadePadrao(){
            return this.modalidadesCadastradas.
                find(modalidade => modalidade.titulo === 'Obras e Serviços de Engenharia')
        }
    },
    created() {
        this.buscarUltimosReajustesPorModalidades()
    },
    methods: {
        async buscarUltimosReajustesPorModalidades() {
            const data = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_ULTIMO_REAJUSTE_POR_MODALIDADE)
            this.ultimosReajustesPorModalidade = [ ...data.ultimosReajustesPorModalidade ]
        },
        async processarEventoBtnNovoReajusteClicado() {
            this.modalidadeSelecionada=null
            this.historicoReajustes=[]
            this.ehTelaHistoricoReajuste = true
        },
        async processarEventoVisualizarHistorico(modalidadeId) {
            await this.buscarModalidadeIndicePreco()
            this.modalidadeSelecionada = this.modalidadesCadastradas.find(modalidade => modalidade.id === modalidadeId)
            this.dadosReajusteCorrente.modalidade = {id: modalidadeId}
            await this.buscarHistoricoReajustePorModalidade(modalidadeId)
            this.ehTelaHistoricoReajuste = true
        },
        processarEventoVoltarParaListagem(){
            this.buscarUltimosReajustesPorModalidades()
            Object.assign(this.dadosReajusteCorrente, reajusteCorrente)
            this.ehTelaHistoricoReajuste = false
        },
        async buscarModalidadeIndicePreco() {
            const data = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_MODALIDADE_INDICE_PRECO)
            this.modalidadesCadastradas = [ ...data.modalidades ]
        },
        async processarEventoSalvarTipo(payload) {
            await this.$store.dispatch(actionTypes.COMPRADOR.ADICIONAR_MODALIDADE_INDICE_PRECO, payload)
        },

        atribuirIndiceSalvoAoHistoricoReajustes(indiceReajuste) {
            const obj = {
                id: indiceReajuste.id,
                ano: indiceReajuste.ano,
                indicador: indiceReajuste.indicador,
                valorBase: indiceReajuste.valorBase,
                percentualReajuste: indiceReajuste.percentualReajuste,
                valorAtualizado: indiceReajuste.valorAtualizado,
                dataCadastro: indiceReajuste.dataCadastro,
                modalidadeId: indiceReajuste.modalidade.id
            }

            this.historicoReajustes.unshift(obj)
        },

        async processarEventoConfirmarCriarNovaModalidade(payload) {
            try {
                const data = await this.$store.dispatch(actionTypes.COMPRADOR.ADICIONAR_MODALIDADE_INDICE_PRECO, payload)
                this.modalidadesCadastradas.push(data)

                this.mostrarNotificacaoSucessoDefault()
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            }
            this.deveMostarModalNovaModalidade = false
        },
        async buscarHistoricoReajustePorModalidade(modalidadeId) {
            const data = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_HISTORICO_REAJUSTE_POR_MODALIDADE, modalidadeId)
            this.historicoReajustes = [...data.reajustes]
        },
        async processarEventoModalidadeChanged(modalidade) {
            Object.assign(this.dadosReajusteCorrente, reajusteCorrente)
            this.dadosReajusteCorrente.modalidade = {...modalidade}
            await this.buscarHistoricoReajustePorModalidade(modalidade.id)
        },
        async processarEventoRemoverReajuste(reajuste){
            try {
                const payload = {
                    modalidadeId: reajuste.modalidadeId,
                    reajusteId: reajuste.id
                }
                await this.$store.dispatch(actionTypes.COMPRADOR.REMOVER_REAJUSTE_INDICE_PRECO, payload)
                this.mostrarNotificacaoSucessoDefault()
            } catch (e) {
                this.mostrarNotificacaoErro(`Falha ao excluir, motivo: ${e.message}`)
            }
            await this.buscarHistoricoReajustePorModalidade(reajuste.modalidadeId)
        },
        async processarEventoEditarPercReajuste(reajuste){
            await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_PERCENTUAL_REAJUSTE, reajuste)
            await this.buscarHistoricoReajustePorModalidade(reajuste.modalidadeId)
        },
        async processarEventoSalvarReajusteEmLote() {
            await this.$store.dispatch(actionTypes.COMPRADOR.SALVAR_REAJUSTE_INDICE_PRECO_EM_MASSA, {...this.dadosReajusteEmLote})

            await this.buscarUltimosReajustesPorModalidades()

            Object.assign(this.dadosReajusteEmLote, reajusteEmLote)
            this.mostrarNotificacaoSucessoDefault()
        },
        async processarEventoSalvarNovoReajuste(dadosReajuste) {
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.CRIAR_REAJUSTE_INDICE_PRECO, dadosReajuste)
                this.mostrarNotificacaoSucessoDefault()
            } catch (e) {
                this.mostrarNotificacaoErro(`Falha ao salvar reajusete, motivo: ${e.message}`)
            }
            await this.buscarHistoricoReajustePorModalidade(dadosReajuste.modalidade.id)
        },
    }
}
</script>

<style scoped lang="stylus">

    .indice-preco-page-container
        position relative

</style>